module.exports = __webpack_public_path__ + "static/media/thum3.a51d6c3f.jpg";